"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _detectrtc = _interopRequireDefault(require("detectrtc"));

var inputSources = _detectrtc.default.audioInputDevices;
var audioInputSourcesMap = {};
var outputSources = _detectrtc.default.audioOutputDevices;
var audioOutputSourcesMap = {};
var audioLabelMap = {};

for (var i = 0; i < inputSources.length; i += 1) {
  if (!audioLabelMap[inputSources[i].label]) {
    audioLabelMap[inputSources[i].label] = [];
  }

  audioInputSourcesMap[inputSources[i].deviceId] = i;
}

for (var _i = 0; _i < outputSources.length; _i += 1) {
  if (!audioLabelMap[outputSources[_i].label]) {
    audioLabelMap[outputSources[_i].label] = [];
  }

  audioOutputSourcesMap[outputSources[_i].deviceId] = _i;
}

var _default = {
  hasWebcam: _detectrtc.default.hasWebcam,
  hasMicrophone: _detectrtc.default.hasMicrophone,
  hasSpeakers: _detectrtc.default.hasSpeakers,
  isSetSinkIdSupported: _detectrtc.default.isSetSinkIdSupported,
  isScreenCapturingSupported: _detectrtc.default.isScreenCapturingSupported,
  isSctpDataChannelsSupported: _detectrtc.default.isSctpDataChannelsSupported,
  isAudioContextSupported: _detectrtc.default.isAudioContextSupported,
  isWebRTCSupported: _detectrtc.default.isWebRTCSupported,
  isDesktopCapturingSupported: _detectrtc.default.isDesktopCapturingSupported,
  isMobileDevice: _detectrtc.default.isMobileDevice,
  isWebSocketsSupported: _detectrtc.default.isWebSocketsSupported,
  isWebSocketsBlocked: _detectrtc.default.isWebSocketsBlocked,
  isWebsiteHasWebcamPermissions: _detectrtc.default.isWebsiteHasWebcamPermissions,
  isWebsiteHasMicrophonePermissions: _detectrtc.default.isWebsiteHasMicrophonePermissions,
  audioInputDevices: _detectrtc.default.audioInputDevices,
  audioInputSourcesMap: audioInputSourcesMap,
  audioLabelMap: audioLabelMap,
  audioOutputDevices: _detectrtc.default.audioOutputDevices,
  audioOutputSourcesMap: audioOutputSourcesMap,
  videoInputDevices: _detectrtc.default.videoInputDevices,
  osName: _detectrtc.default.osName,
  osVersion: _detectrtc.default.osVersion,
  isCanvasSupportsStreamCapturing: _detectrtc.default.isCanvasSupportsStreamCapturing,
  isVideoSupportsStreamCapturing: _detectrtc.default.isVideoSupportsStreamCapturing
};
exports.default = _default;
module.exports = exports.default;